import { render, staticRenderFns } from "./Drag-drop-uploader.vue?vue&type=template&id=24d79ed3&"
import script from "./Drag-drop-uploader.vue?vue&type=script&lang=js&"
export * from "./Drag-drop-uploader.vue?vue&type=script&lang=js&"
import style0 from "./Drag-drop-uploader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports